// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.listingcriteria.RentalManagerListingCriteriaType

export enum RentalManagerListingCriteriaType {
  CREDIT_SCORE_MIN = 'creditScore',
  INCOME_TO_RENT_RATIO = 'incomeToRent',
  PET_POLICY_CAT_COUNT = 'petPolicyCatCount',
  /**
   * @deprecated
   */
  PET_POLICY_DOG_COUNT = 'petPolicyDogCount',
  /**
   * @deprecated
   */
  PET_POLICY_DOG_SIZE = 'petPolicyDogSize',
  PET_POLICY_LARGE_DOG_COUNT = 'petPolicyLargeDogCount',
  PET_POLICY_PET_DEPOSIT = 'petPolicyPetDeposit',
  PET_POLICY_PET_RENT = 'petPolicyPetRent',
  PET_POLICY_SMALL_DOG_COUNT = 'petPolicySmallDogCount',
}

export const RentalManagerListingCriteriaType_values = [
  RentalManagerListingCriteriaType.CREDIT_SCORE_MIN,
  RentalManagerListingCriteriaType.INCOME_TO_RENT_RATIO,
  RentalManagerListingCriteriaType.PET_POLICY_CAT_COUNT,
  RentalManagerListingCriteriaType.PET_POLICY_DOG_COUNT,
  RentalManagerListingCriteriaType.PET_POLICY_DOG_SIZE,
  RentalManagerListingCriteriaType.PET_POLICY_LARGE_DOG_COUNT,
  RentalManagerListingCriteriaType.PET_POLICY_PET_DEPOSIT,
  RentalManagerListingCriteriaType.PET_POLICY_PET_RENT,
  RentalManagerListingCriteriaType.PET_POLICY_SMALL_DOG_COUNT,
] as const;
